import { Button, Dialog, DialogContent, DialogTitle, Divider, FormHelperText, Grid, IconButton, InputAdornment, Stack, TextField, Typography } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import DraggablePaper from "../common/DraggablePaper";
import { CONTENT_COLOR, MAIN_HEADER_COLOR, MAIN_HEADER_COLOR_TOP } from "../../models/Constants";
import { useEffect, useState } from "react";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

export type ShowQuestionListProps = {
    data:any
    onCancel: () => void;
};

export const ShowQuestionListDialog = (props: ShowQuestionListProps) => {
    //#region fields
    const { data,onCancel } = props;

    const [questionList,setQuestionList] = useState(data)
    //#endregion fields

    //#region methods

    //#endregion methods

    return (
        <>
            <Dialog open={true} maxWidth={"md"} fullWidth
                PaperComponent={
                    DraggablePaper
                }
            >
                {/* <DialogTitle 
                    onMouseOver={(e : any) => e.target.style.cursor = 'move'}
                    style={{ paddingTop: '2px', paddingBottom: '2px', background: MAIN_HEADER_COLOR, color: 'white' }}
                >
                </DialogTitle>
                <Divider/> */}
                <DialogContent style={{ display: 'flex', alignItems: 'flex-end',background: MAIN_HEADER_COLOR_TOP}}>
                    <div style={{width: '100%'}}>
                        <Stack direction='row' justifyContent="space-between" alignItems="center" sx={{ mb:2 }}>
                            <Typography variant="h5" color={CONTENT_COLOR}>質問内容</Typography>
                            <Button variant="contained" color="info" onClick={onCancel}>閉じる</Button>
                        </Stack>
                        <Stack  direction={"column"} maxHeight={"50vh"} width={"100%"} overflow={"auto"} alignSelf={"center"} mb={2}>
                            {
                                questionList && questionList.map((item:any,index:any)=>{
                                    return(<>
                                    <Grid container direction={"row"} alignItems={"center"} width={"100%"} mt={1} mb={1}>
                                        <Grid item xs={1.5}>{'Q' + item.questionNo}</Grid>
                                        <Grid item xs={10.5}>{item.content}</Grid>
                                    </Grid>
                                    <Divider/>
                                    </>)
                                })
                            }
                        </Stack>
                    </div>                    
                </DialogContent>
            </Dialog>
        </>
    )
}
export default ShowQuestionListDialog;